const QUOTA_MESSAGES = {
    default: {
        title: (limit) => window.i18n.__("Vous avez atteint une limite"),
        message: window.i18n.__("Vous pouvez contacter l'équipe Sellsy pour faire évoluer votre abonnement."),
    },
    pipelines: {
        title: (limit) => window.i18n.n__("Vous avez déjà ajouté %(limit)s pipeline.", "Vous avez déjà ajouté %(limit)s pipelines.", limit, {limit}),
        message: window.i18n.__("Si vous souhaitez ajouter un nouveau pipeline vous pouvez supprimer un pipeline déjà existant ou vous pouvez également contacter l'équipe Sellsy pour faire évoluer votre abonnement."),
    },
    privilege_profiles: {
        title: (limit) => window.i18n.n__("Vous avez déjà ajouté %(limit)s profil de privilège", "Vous avez déjà ajouté %(limit)s profils de privilèges", limit, {limit}),
        message: window.i18n.__("Si vous souhaitez ajouter un nouveau profil vous pouvez supprimer un profil déjà existant ou vous pouvez également contacter l'équipe Sellsy pour faire évoluer votre abonnement."),
    },
    custom_fields: {
        title: (limit) => window.i18n.n__("Vous avez déjà ajouté %(limit)s champ personnalisé.", "Vous avez déjà ajouté %(limit)s champ personnalisés.", limit, {limit}),
        message: window.i18n.__("Si vous souhaitez ajouter un nouveau champ personnalisé vous pouvez supprimer un champ personnalisé déjà existant ou vous pouvez également contacter l'équipe Sellsy pour faire évoluer votre abonnement."),
    },
    estimate_dunning_plan: {
        title: (limit) => window.i18n.n__("Vous avez déjà ajouté %(limit)s plan de relance des devis.", "Vous avez déjà ajouté %(limit)s plans de relance des devis.", limit, {limit}),
        message: window.i18n.__("Si vous souhaitez ajouter un nouveau plan de relance des devis vous pouvez supprimer un plan de relance des devis déjà existant ou vous pouvez également contacter l'équipe Sellsy pour faire évoluer votre abonnement."),
    },
    invoice_dunning_plan: {
        title: (limit) => window.i18n.n__("Vous avez déjà ajouté %(limit)s plan de relance des factures.", "Vous avez déjà ajouté %(limit)s plans de relance des factures.", limit, {limit}),
        message: window.i18n.__("Si vous souhaitez ajouter un nouveau plan de relance des factures vous pouvez supprimer un plan de relance des factures déjà existant ou vous pouvez également contacter l'équipe Sellsy pour faire évoluer votre abonnement."),
    },
    proforma_dunning_plan: {
        title: (limit) => window.i18n.n__("Vous avez déjà ajouté %(limit)s plan de relance Proforma.", "Vous avez déjà ajouté %(limit)s plans de relance Proforma.", limit, {limit}),
        message: window.i18n.__("Si vous souhaitez ajouter un nouveau plan de relance proforma vous pouvez supprimer un plan de relance proforma déjà existant ou vous pouvez également contacter l'équipe Sellsy pour faire évoluer votre abonnement."),
    }
}

window.Quota = {

    /**
     * Private -- Return all quotas limit
     * @returns {Promise}
     */
    _getQuotas () {
        return window.ApiClient.get('/quotas');
    },


    /**
     * Private -- Check if quota limit exist for context
     * @param {object} quotas 
     * @param {array} context 
     * @returns 
     */
    _hasLimitOnContext(quotas, context) {
        return !!quotas[context];
    },

    /**
     * Private -- Check if quota limit is reached
     * @param {object} quotas 
     * @param {array} context 
     * @returns 
     */
    _isReachedLimit(quotas, context) {
        const {limit, used} = quotas[context];
        return !!limit && used >= limit;
    },

    /**
     * Check if the quotas are reached,  
     * in function, replace or not the action of the button with the corresponding guard quota
     * 
     * @param {*} checkList 
     * @return {Promise}
     */
    checkQuotas (checkList) {
        return this._getQuotas()
            .then(({data}) => {
                for (const context of checkList) {
                    if (this._hasLimitOnContext(data, context) && this._isReachedLimit(data, context)) {
                        const guardsList = [...document.querySelectorAll('[data-quota-guard]')];

                        if (window.sellsyapp.$store.state.corp.pricingVersion >= 5) {
                            guardsList
                            .filter(el => el.dataset.quotaGuard === context)
                            .forEach(el => {
                                if (['privilege_profiles','custom_fields', 'rate_categories'].includes(context)) {

                                    const clone = el.cloneNode(true);
                                    if (clone.getAttribute('onclick')) {
                                        clone.removeAttribute('onclick');
                                    }
                                    if (clone.getAttribute('href')) {
                                        clone.removeAttribute('href');
                                    }
                
                                    clone.classList.add('upsell-action');
                
                                    const featureBadge = document.querySelector('#featureBadge').cloneNode(true);
                                    featureBadge.removeAttribute('style');
                                    featureBadge.removeAttribute('id');
                
                                    clone.appendChild(featureBadge);
                
                                    clone.addEventListener('click', () => {
                                        window.sellsyapp.$store.state.popupPanel.featureModal.props = {
                                            feature: context,
                                        };
                                        window.sellsyapp.$store.state.popupPanel.featureModal.display = true;
                                    });
                
                                    el.replaceWith(clone);
                                } else {
                                    el.onclick = () => Quota.showLimitReached(context, data[context].limit)
                                }
                            })
                        } else {
                            guardsList
                            .filter(el => el.dataset.quotaGuard === context)
                            .forEach(el => el.onclick = () => Quota.showLimitReached(context, data[context].limit))
                        }
                    }
                }
                
            })
            .catch(err => Push.error(window.i18n.__("Problème lors de la récupération des données")));
    },

    /**
     * Active the quota popup with appropriate message
     * @param {*} context 
     * @param {*} limit 
     * @returns 
     */
    showLimitReached (context, limit) {

        // if not found quota message, apply messages by default
        if (!QUOTA_MESSAGES[context]) context = 'default';

        const {title, message} = QUOTA_MESSAGES[context];

        window.sellsyapp.$store.state.popupPanel.popupQuotaLimit.props = {title:title(limit), message};
        window.sellsyapp.$store.state.popupPanel.popupQuotaLimit.display = true;
    }
}
